import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  PieChart,
  Pie,
  Cell,
  Legend,
} from 'recharts';

import { DashboardLayout } from '@/components/dashboard/DashboardLayout';
import { PageHeader } from '@/components/dashboard/PageHeader';
import { cityBreakdown, gameBreakdown } from '@/lib/mockData';

const COLORS = ['hsl(var(--primary))', 'hsl(var(--accent))', 'hsl(var(--primary-glow))'];

const AdminAnalytics = () => (
  <DashboardLayout
    role="admin"
    user={{ name: 'Équipe Winkô', subtitle: 'Super Admin', initials: 'WK' }}
  >
    <PageHeader
      title="Analytics géo"
      subtitle="Répartition géographique et insights IA sur l'usage."
    />
    <div className="grid gap-6 lg:grid-cols-2">
      <div className="rounded-2xl border border-border bg-card p-6 shadow-soft">
        <h3 className="font-display text-lg font-bold">Top villes</h3>
        <div className="mt-4 h-72">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={cityBreakdown}>
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} />
              <XAxis
                dataKey="city"
                stroke="hsl(var(--muted-foreground))"
                fontSize={11}
                tickLine={false}
                axisLine={false}
              />
              <YAxis
                stroke="hsl(var(--muted-foreground))"
                fontSize={11}
                tickLine={false}
                axisLine={false}
              />
              <Tooltip
                contentStyle={{
                  background: 'hsl(var(--card))',
                  border: '1px solid hsl(var(--border))',
                  borderRadius: 12,
                  fontSize: 12,
                }}
              />
              <Bar dataKey="value" radius={[8, 8, 0, 0]} fill="hsl(var(--primary))" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="rounded-2xl border border-border bg-card p-6 shadow-soft">
        <h3 className="font-display text-lg font-bold">Mix des jeux</h3>
        <div className="mt-4 h-72">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={gameBreakdown}
                dataKey="value"
                nameKey="game"
                outerRadius={90}
                innerRadius={50}
              >
                {gameBreakdown.map((_, i) => (
                  <Cell key={i} fill={COLORS[i % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip
                contentStyle={{
                  background: 'hsl(var(--card))',
                  border: '1px solid hsl(var(--border))',
                  borderRadius: 12,
                  fontSize: 12,
                }}
              />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
    <div className="mt-6 rounded-2xl border border-primary/20 bg-primary/5 p-6">
      <p className="text-xs font-semibold uppercase tracking-wider text-primary">Insight IA</p>
      <p className="mt-2 font-display text-lg font-bold">
        Les campagnes Roulette à Abidjan convertissent 22 % mieux le vendredi soir (19 h–23 h).
      </p>
      <p className="mt-1 text-sm text-muted-foreground">
        Recommandation : pousser les notifications partenaires sur ce créneau pour maximiser
        l'engagement.
      </p>
    </div>
  </DashboardLayout>
);

export default AdminAnalytics;
